/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
export const FETCH_GENERATE_CLIENT_REQUEST = "FETCH_GENERATE_CLIENT_REQUEST";
export const FETCH_GENERATE_CLIENT_SUCCESS = "FETCH_GENERATE_CLIENT_SUCCESS";
export const FETCH_GENERATE_CLIENT_FAILURE = "FETCH_GENERATE_CLIENT_FAILURE";
